module.exports = __webpack_public_path__ + "img/01.590c0e38.png";